var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.5003H13M2.5 22.0003L8.04927 19.866C8.40421 19.7295 8.58168 19.6612 8.74772 19.5721C8.8952 19.4929 9.0358 19.4015 9.16804 19.2989C9.31692 19.1834 9.45137 19.0489 9.72028 18.78L21 7.5003C22.1046 6.39574 22.1046 4.60487 21 3.5003C19.8955 2.39573 18.1046 2.39573 17 3.5003L5.72028 14.78C5.45138 15.0489 5.31692 15.1834 5.20139 15.3323C5.09877 15.4645 5.0074 15.6051 4.92823 15.7526C4.83911 15.9186 4.77085 16.0961 4.63433 16.451L2.5 22.0003ZM2.5 22.0003L4.55812 16.6493C4.7054 16.2663 4.77903 16.0749 4.90534 15.9872C5.01572 15.9105 5.1523 15.8816 5.2843 15.9068C5.43533 15.9356 5.58038 16.0807 5.87048 16.3708L8.12957 18.6299C8.41967 18.9199 8.56472 19.065 8.59356 19.216C8.61877 19.348 8.58979 19.4846 8.51314 19.595C8.42545 19.7213 8.23399 19.7949 7.85107 19.9422L2.5 22.0003Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilLineIcon);
export default __webpack_public_path__ + "static/media/pencil-line-icon.e7e599b177098f659cd0cb7678a050ce.svg";
export { ForwardRef as ReactComponent };